export const INVALID_EMAIL = 'INVALID_EMAIL';
